import {createFileRoute} from '@tanstack/react-router';
import {viewDiagnosticReportGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import DiagnosticReports from '@/practitioner/views/diagnosticReport/DiagnosticReportResult';

export const Route = createFileRoute('/(practitioner)/diagnostic-reports')({
  component: DiagnosticReports,
  beforeLoad: grantUser(viewDiagnosticReportGranted)
});
